import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import EcoLink from 'eco-design/base/eco-link';
import { useRouter } from 'next/router';

/** 预热 / 正式页状态 */
enum EnumPageStatus {
    /** 预热页 */
    PRESALE = 'PRESALE',
    /** 正式页 */
    LAUNCH = 'LAUNCH',
}

interface ItfTimeLine {
    time: number;
    stage: EnumPageStatus;
}

type PdfBarSite = 'us' | 'ca';

/**
 * 各站点时间线（北京时间 GMT+8）
 * - 9.8 预热页
 * - 9.20 正式页
 */
const pageTimeLineMap: Record<PdfBarSite, ItfTimeLine[]> = {
    us: [
        { time: new Date('2026/09/20 00:00:00 GMT+8').getTime(), stage: EnumPageStatus.LAUNCH },
        { time: new Date('2026/09/08 00:00:00 GMT+8').getTime(), stage: EnumPageStatus.PRESALE },
    ],
    ca: [
        { time: new Date('2026/09/20 00:00:00 GMT+8').getTime(), stage: EnumPageStatus.LAUNCH },
        { time: new Date('2026/09/08 00:00:00 GMT+8').getTime(), stage: EnumPageStatus.PRESALE },
    ],
};
const pdfBarMap: Record<
    PdfBarSite,
    Record<EnumPageStatus, { link: string; pc: string; h5: string; title: string; desc: string }>
> = {
    us: {
        [EnumPageStatus.PRESALE]: {
            link: 'https://us.ecoflow.com/pages/prime-day',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1788489889448/PRESALE_us-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1788489888818/PRESALE_us-h5.jpg',
            title: 'Sign Up for Early Access',
            desc: 'EcoFlow Prime Day Fall Sale Is Coming',
        },
        [EnumPageStatus.LAUNCH]: {
            link: 'https://us.ecoflow.com/pages/prime-day',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1788489888620/LAUNCH_us-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1788489888419/LAUNCH_us-h5.jpg',
            title: 'Up to 58% Off',
            desc: 'EcoFlow Prime Day Fall Sale (Sep 20 - Oct 18)',
        },
    },
    ca: {
        [EnumPageStatus.PRESALE]: {
            link: 'https://ca.ecoflow.com/pages/prime-day',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1788489889225/PRESALE_ca-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1788489888202/PRESALE_ca-h5.jpg',
            title: 'Sign Up for Early Access',
            desc: 'EcoFlow Prime Day Fall Sale Is Coming',
        },
        [EnumPageStatus.LAUNCH]: {
            link: 'https://ca.ecoflow.com/pages/prime-day',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1788489889022/LAUNCH_ca-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1788489888030/LAUNCH_ca-h5.jpg',
            title: 'Up to 58% Off',
            desc: 'EcoFlow Prime Day Fall Sale (Sep 22 - Oct 14)',
        },
    },
};

const getPageStatus = (now: number, site: PdfBarSite) => {
    const timeLine = pageTimeLineMap[site];
    if (!timeLine?.length) return '';
    const hit = [...timeLine].sort((a, b) => b.time - a.time).find((item) => now >= item.time);
    return hit?.stage || '';
};

const PdfBar: React.FC<{ site: PdfBarSite }> = ({ site }) => {
    const { query } = useRouter();
    const now = query?._time ? new Date(`${query._time} GMT+8`).getTime() : new Date().getTime();
    const status = getPageStatus(now, site);

    const data = status ? pdfBarMap[site]?.[status] : null;
    if (!data) return null;

    return (
        <EcoLink href={data.link} className={`cost-saving-pdf-bar ${css['cost-saving-pdf-bar']}`}>
            <div className="pdf-bar-img">
                <EFPicture src={data.pc} srcPad={data.h5} alt={data.title} />
            </div>
            <div className="pdf-bar-text">
                <EFPicture src={'https://websiteoss.ecoflow.com/upload/image/1788492715352/pdf-bar.png'} alt={'pdf-bar'} className="pdf-bar-icon" />
                <p className="desc">{data.desc}</p>
                <h2 className="title">{data.title}</h2>
            </div>
        </EcoLink>
    );
};

export default PdfBar;
